import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "stop",
  "use": "stop-usage",
  "viewBox": "0 0 265.405 265.405",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 265.405 265.405\" fill=\"currentColor\" id=\"stop\"><path d=\"M132.703 0C59.53 0 0 59.53 0 132.702s59.53 132.702 132.703 132.702c73.172 0 132.702-59.53 132.702-132.702S205.875 0 132.703 0zm0 250.405C67.801 250.405 15 197.604 15 132.702S67.801 15 132.703 15c64.901 0 117.702 52.801 117.702 117.702s-52.801 117.703-117.702 117.703z\" /><path d=\"M174.816 73.089H90.589c-9.649 0-17.5 7.851-17.5 17.5v84.227c0 9.649 7.851 17.5 17.5 17.5h84.227c9.649 0 17.5-7.851 17.5-17.5V90.589c0-9.649-7.851-17.5-17.5-17.5zm2.5 101.727c0 1.355-1.145 2.5-2.5 2.5H90.589c-1.355 0-2.5-1.145-2.5-2.5V90.589c0-1.355 1.145-2.5 2.5-2.5h84.227c1.355 0 2.5 1.145 2.5 2.5v84.227z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/stop.svg
// module id = KvHR
// module chunks = 38 43